
/* ============================== src/components/PriorityStrip.jsx ============================== */
// src/components/PriorityStrip.jsx
import { memo, useLayoutEffect, useRef } from "react";

export const PriorityStrip = memo(function PriorityStrip({ color }) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty("--strip-color", color);
  }, [color]);

  return <span ref={ref} className="priority-strip" aria-hidden="true" />;
});
